import computed from './attrs/computed'
import data from './attrs/data'
import created from './attrs/created'
import methods from './attrs/methods'
import mounted from './attrs/mounted'
import OrderRefund from '../OrderRefund/Index.vue'

export default {
    name: 'OrderDetails',
    components: {
        OrderRefund
    },
    computed,
    data,
    created,
    methods,
    mounted
}
